import React from 'react';
import '../../assets/css/Residential.css';
import Fade from 'react-reveal/Fade';

class Residences extends React.Component {
    render() {
        return (
            <>
                <div className='resHeader'>
                    <h3>AVAILABLE PROPERTIES FOR SALE</h3>
                    <p>Signature Move Investment Group Ltd offers a wide range of properties ranging from luxury custom-build single-family homes to innovative modern communities and neighborhoods. Located at convenient locations and comes with extensive builders warranty, the properties in our portfolio epitomize contemporary style and offer an unparalleled luxury living experience.</p>
                </div>
                <div className='resContainer' style={{ display: 'flex' }}>
                    <Fade bottom duration={500}>
                        <div className='residence col'>
                            <div className='resImg'>
                                <img width='100%' src='https://static.wixstatic.com/media/2b68ec_21779a6dcf554801be8547cc7d8675a2~mv2.jpg/v1/fill/w_533,h_375,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/2b68ec_21779a6dcf554801be8547cc7d8675a2~mv2.jpg'></img>
                            </div>
                            <div className='resTitle'>
                                <h3>LE CIEL AT PIKESVILLE</h3>
                            </div>
                            <div className='resPrice'>
                                <p>(3) Homes Priced From $2,599,000 to $3,599,000</p>
                            </div>
                            <div className='resAvailability'>
                                <h3>Available for Purchase Now</h3>
                            </div>
                            <div className='resDescription'>
                                <p>Three new single-family homes in sought-after Pikesville in Baltimore County, MD</p>
                            </div>
                            <div className='resButton'>

                            </div>
                        </div>
                    </Fade>
                    <Fade bottom duration={700}>
                        <div className='residence col'>
                            <div className='resImg'>
                                <img width='100%' src='https://static.wixstatic.com/media/2b68ec_dc1bd2f236ee43b194bb4a2256ecb8bb~mv2.jpg/v1/fill/w_533,h_375,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/2b68ec_dc1bd2f236ee43b194bb4a2256ecb8bb~mv2.jpg'></img>
                            </div>
                            <div className='resTitle'>
                                <h3>SOLEIL AT BOWIE</h3>
                            </div>
                            <div className='resPrice'>
                                <p>(3) Homes Priced From $2,599,000 to $3,599,000+</p>
                            </div>
                            <div className='resAvailability'>
                                <h3>Available for Purchase Now</h3>
                            </div>
                            <div className='resDescription'>
                                <p>A private community of 21 luxury single-family homes in the heart of Bowie, MD</p>
                            </div>
                            <div className='resButton'>

                            </div>
                        </div>
                    </Fade>
                    <Fade bottom duration={500}>
                        <div className='residence col'>
                            <div className='resImg'>
                                <img width='100%' src='https://static.wixstatic.com/media/2b68ec_06a2a14d73674047a3b7a804be3ff4be~mv2.png/v1/fill/w_533,h_375,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_auto/2b68ec_06a2a14d73674047a3b7a804be3ff4be~mv2.png'></img>
                            </div>
                            <div className='resTitle'>
                                <h3>UMMI ROW</h3>
                            </div>
                            <div className='resPrice'>
                                <p>(10) Homes Priced From $6,000,000 - $7,000,000</p>
                            </div>
                            <div className='resAvailability'>
                                <h3>Coming Soon</h3>
                            </div>
                            <div className='resDescription'>
                                <p>A 10-unit upscale elevator townhome community in Glen Burnie, MD</p>
                            </div>
                            <div className='resButton'>

                            </div>
                        </div>
                    </Fade>
                </div>
            </>
        )
    }
}
export default Residences;